import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { TokenService } from '../../token-service/token.service';

export const AuthCompleteGuard: CanMatchFn = () => {
  const tokenService = inject(TokenService);
  const cookieService = inject(CookieService);
  const router = inject(Router);

  const token = tokenService.getToken() || cookieService.get('webpay-token');
  console.log('AuthCompleteGuard token:');
  if (!token) {
    return router.createUrlTree(['/']);
  }

  tokenService.setToken(token);

  return true;
};
